import { sub } from 'date-fns';

export const SIX_MONTHS_AGO = sub(new Date(), { months: 6 });
export const ONE_YEAR_AGO = sub(new Date(), { months: 12 });
